import { render, staticRenderFns } from "./create-gasthreshold.vue?vue&type=template&id=128b54f1&"
import script from "./create-gasthreshold.vue?vue&type=script&lang=ts&"
export * from "./create-gasthreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports